export let warningEnabled = true;

export const setInstantWarningsEnabled = (enabled: boolean) => {
  warningEnabled = enabled;
};
